import { ConfigProvider, DatePicker } from 'antd';
import type { CSSProperties } from 'react';
import {
    dateFormat,
    isDateOutsideRange,
    PICKER_CLASS_NAME,
    pickerPopupProps,
    toDateValue,
    useDateTimePicker,
    type Dayjs,
} from './pickerShared';

export interface AppDatePickerProps {
    value?: string;
    defaultValue?: string;
    onChange: (isoDate: string) => void;
    disabled?: boolean;
    allowClear?: boolean;
    min?: string;
    max?: string;
    disabledDate?: (date: Dayjs) => boolean;
    id?: string;
    size?: 'small' | 'middle';
    onOpenChange?: (open: boolean) => void;
    style?: CSSProperties;
    className?: string;
}

const AppDatePicker = ({
    value,
    defaultValue,
    onChange,
    disabled = false,
    allowClear = false,
    min,
    max,
    disabledDate,
    id,
    size = 'middle',
    onOpenChange,
    style,
    className,
}: AppDatePickerProps) => {
    const { locale, theme } = useDateTimePicker();
    const valueProps = value !== undefined
        ? { value: toDateValue(value) }
        : { defaultValue: toDateValue(defaultValue || '') };

    return (
        <ConfigProvider locale={locale} theme={theme}>
            <DatePicker
                {...pickerPopupProps}
                {...valueProps}
                id={id}
                size={size}
                className={[PICKER_CLASS_NAME, className].filter(Boolean).join(' ')}
                format={dateFormat}
                disabled={disabled}
                allowClear={allowClear}
                inputReadOnly={false}
                disabledDate={(date) =>
                    isDateOutsideRange(date, min, max) || Boolean(disabledDate?.(date))
                }
                onChange={(date) => onChange(date?.format('YYYY-MM-DD') ?? '')}
                onOpenChange={onOpenChange}
                style={{ width: '100%', ...style }}
            />
        </ConfigProvider>
    );
};

export default AppDatePicker;
